import { hsaOrderContext } from "@redotech/redo-conversion-hsa-common/hsa-order-context";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

// Server-to-server endpoint called from the merchant's storefront/checkout
// when the shopper elects HSA payment. Mints a new session and returns the
// public token UUID — that token becomes the URL capability for the
// customer-portal questionnaire (`/hsa/<sessionToken>`).
//
// `completedRedirectUrl` is where the customer is sent after the
// questionnaire + LMN + payment flow finishes. Stored on the session so the
// merchant doesn't have to thread it through later RPCs.
export const createHsaSession = unaryRpc({
  name: "createHsaSession",
  input: z.object({
    orderContext: hsaOrderContext,
    completedRedirectUrl: z.string().url(),
  }),
  output: z.object({ sessionToken: z.string().uuid() }),
});
